import { render, staticRenderFns } from "./RestaurantTable.vue?vue&type=template&id=68ef5c37&scoped=true&"
import script from "./RestaurantTable.vue?vue&type=script&lang=js&"
export * from "./RestaurantTable.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantTable.vue?vue&type=style&index=0&id=68ef5c37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ef5c37",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VSimpleTable,VSpacer,VSystemBar})
